/**
 * Resources Services Module
 * Exports all resource management services and factory functions
 */
// Service exports
export * from './CourseService';
export * from './CourseCategoryService';
export * from './CourseSessionService';
export * from './UsageLogService';
export * from './CourseStatusService';
export * from './CourseCategoryStatusService';
export * from './CourseSessionStatusService';
export * from './CourseSessionTypeService';
export * from './PublicCoursesService';
export * from './PublicCategoriesService';
export * from './UserCourseProgressService';
export * from './UserSessionProgressService';
export * from './SessionNoteService';
export * from './UserProgressStatusService';
export * from './CourseVisibilityService';
export * from './CoursePrerequisiteService';
export * from './ResourceUsageActionService';
export * from './ResourceSettingsService';
export * from './ResourceMediaService';
// Service imports for factory
import { CourseService } from './CourseService';
import { CourseCategoryService } from './CourseCategoryService';
import { CourseSessionService } from './CourseSessionService';
import { UsageLogService } from './UsageLogService';
import { CourseStatusService } from './CourseStatusService';
import { CourseCategoryStatusService } from './CourseCategoryStatusService';
import { CourseSessionStatusService } from './CourseSessionStatusService';
import { CourseSessionTypeService } from './CourseSessionTypeService';
import { PublicCoursesService, PublicCategoriesEnrichedService } from './PublicCoursesService';
import { PublicCategoriesService } from './PublicCategoriesService';
import { UserCourseProgressService } from './UserCourseProgressService';
import { UserSessionProgressService } from './UserSessionProgressService';
import { SessionNoteService } from './SessionNoteService';
import { UserProgressStatusService } from './UserProgressStatusService';
import { CourseVisibilityService } from './CourseVisibilityService';
import { CoursePrerequisiteService } from './CoursePrerequisiteService';
import { ResourceUsageActionService } from './ResourceUsageActionService';
import { ResourceSettingsService } from './ResourceSettingsService';
import { ResourceMediaService } from './ResourceMediaService';
/**
 * Create all resources services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all resources service instances
 */
export function createResourcesServices(http, config) {
    return {
        course: new CourseService(http, config),
        courseCategory: new CourseCategoryService(http, config),
        courseSession: new CourseSessionService(http, config),
        usageLog: new UsageLogService(http, config),
        courseStatus: new CourseStatusService(http, config),
        courseCategoryStatus: new CourseCategoryStatusService(http, config),
        courseSessionStatus: new CourseSessionStatusService(http, config),
        courseSessionType: new CourseSessionTypeService(http, config),
        publicCourses: new PublicCoursesService(http, config),
        publicCategories: new PublicCategoriesService(http, config),
        publicCategoriesEnriched: new PublicCategoriesEnrichedService(http, config),
        userCourseProgress: new UserCourseProgressService(http, config),
        userSessionProgress: new UserSessionProgressService(http, config),
        sessionNote: new SessionNoteService(http, config),
        userProgressStatus: new UserProgressStatusService(http, config),
        courseVisibility: new CourseVisibilityService(http, config),
        coursePrerequisite: new CoursePrerequisiteService(http, config),
        resourceUsageAction: new ResourceUsageActionService(http, config),
        resourceSettings: new ResourceSettingsService(http, config),
        resourceMedia: new ResourceMediaService(http, config),
    };
}
//# sourceMappingURL=index.js.map